import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function updateRecordingS3Key(
  appointmentId: string | number,
  newS3Key: string,
) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/transcription/appointment/${appointmentId}/recording_s3_key`,
    {
      method: "POST",
      body: JSON.stringify({
        s3_key: newS3Key,
      }),
    },
  );
  if (!res.ok) {
    const responseText = await res.text();
    console.error(getErrorDetail(responseText));
  }
}
